import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'

// Tailwind + design system
import '@/assets/styles/tailwind.css'

// Import de l'API pour s'assurer que les configurations sont appliquées
import api from './services/api'

// Correctif de sécurité global pour forcer HTTPS en production
if (
  !import.meta.env.DEV &&
  typeof window !== 'undefined' &&
  window.location.protocol === 'https:'
) {
  // Intercepter toutes les requêtes XMLHttpRequest pour forcer HTTPS
  const originalOpen = XMLHttpRequest.prototype.open
  XMLHttpRequest.prototype.open = function (method, url, ...args) {
    if (typeof url === 'string' && url.startsWith('http://')) {
      url = url.replace('http://', 'https://')
    }
    return originalOpen.call(this, method, url, ...args)
  }

  // Intercepter fetch également
  const originalFetch = window.fetch
  window.fetch = function (input, init) {
    if (typeof input === 'string' && input.startsWith('http://')) {
      input = input.replace('http://', 'https://')
    }
    return originalFetch.call(this, input, init)
  }
}

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.mount('#app')
